import { withDependencies } from '@wix/thunderbolt-ioc'
import type { INavigationManager } from './types'
import { createPromise } from '@wix/thunderbolt-commons'

export const NavigationManager = withDependencies(
	[],
	(): INavigationManager => {
		let isDuringNavigation = false
		let _shouldBlockRender = false
		let isFirstNavigation = true
		let navAwaiterResolvers: Array<(isLast: boolean) => void> = []
		return {
			endNavigation: () => {
				isDuringNavigation = false
				isFirstNavigation = false
				navAwaiterResolvers.forEach((resolver, idx) => resolver(idx === navAwaiterResolvers.length - 1))
				navAwaiterResolvers = []
			},
			setShouldBlockRender: (shouldBlockRender: boolean) => {
				_shouldBlockRender = shouldBlockRender
			},
			isDuringNavigation: () => isDuringNavigation,
			shouldBlockRender: () => _shouldBlockRender,
			isFirstNavigation: () => isFirstNavigation,
			startNavigation: () => {
				isDuringNavigation = true
			},
			waitForShouldContinueNavigation: () => {
				const { resolver, promise } = createPromise<boolean>()
				navAwaiterResolvers.push(resolver)
				return promise
			},
		}
	}
)
